import 'react-app-polyfill/ie11';

import dotenv from 'dotenv';
import { Provider } from 'mobx-react';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';

import stores from './@stores';
dotenv.config();

const rootEl = document.getElementById('root');
/* eslint-disable-next-line */
ReactDOM.render(<Provider {...stores} >
    <BrowserRouter basename={process.env.PUBLIC_URL}><App /></BrowserRouter>
</Provider>, rootEl);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
